import React from "react";
import practice_img_1 from "../../assets/images/practice-img-1.jpg";
import practice_img_4 from "../../assets/images/practice-img-4.jpg";
import practice_img_5 from "../../assets/images/practice-img-5.jpg";
const HomePageBlog = () => {
  return (
    <div
      className="bg-transparent pt-[60px] flex justify-center items-center pb-[120px]"
      style={{
        backgroundImage: "linear-gradient(180deg, #D6ECE1 0%, #FFFFFF 100%)",
      }}
    >
      <div className="xl:w-[75%] w-[90%] flex  flex-col gap-3 mb-14 items-center justify-center ">
        <div className=" text-[#cfa649] text-2xl font-playfair">
          {" "}
          Newest News
        </div>
        <h2 className="text-[#17543E] text-4xl font-bold font-playfair">
          From our Blog
        </h2>
        <div className="w-full flex flex-col mb-4 mt-8 md:flex-row">
          <div className="md:w-1/3  w-full  p-4">
            <div className="flex flex-col w-full border-[1px] bg-white">
              <div className="w-full ">
                <img
                  src={practice_img_1}
                  alt="practice_img_1"
                  className="object-cover"
                />
              </div>
              <div className="p-6 flex flex-col gap-4 ">
                <h3 className="text-xl font-playfair text-[#17543e] font-medium">
                  <a href="inhale-namaste-mudra-bandha">
                    {" "}
                    Breath of fire inhale
                  </a>
                </h3>
                <p className="text-[#525C58] font-raleway text-[16px] font-normal">
                  Cras tempus, nunc a blandit porttitor, nunc ligula ornare
                  orci, nec vestibulum odio neque non
                </p>
                <a className="font-xl font-raleway font-[600] text-[#cfa649]" href="/">Learn More</a>
              </div>
            </div>
          </div>
          <div className="md:w-1/3  w-full   p-4">
            <div className="flex flex-col bg-white w-full border-[1px]">
              <div className="w-full ">
                <img
                  src={practice_img_5}
                  alt="practice_img_1"
                  className="object-cover"
                />
              </div>
               <div className="p-6 flex flex-col gap-4 ">
                <h3 className="text-xl font-playfair text-[#17543e] font-medium">
                  <a href="inhale-namaste-mudra-bandha">
                    {" "}
                    Breath of fire inhale
                  </a>
                </h3>
                <p className="text-[#525C58] font-raleway text-[16px] font-normal">
                  Cras tempus, nunc a blandit porttitor, nunc ligula ornare
                  orci, nec vestibulum odio neque non
                </p>
                <a className="font-xl font-raleway font-[600] text-[#cfa649]" href="/">Learn More</a>
              </div>
             
            </div>
          </div>
          <div className="md:w-1/3  w-full  p-4">
            <div className="flex flex-col w-full bg-white border-[1px]">
              <div className="w-full ">
                <img
                  src={practice_img_4}
                  alt="practice_img_1"
                  className="object-cover"
                />
              </div>
              <div className="p-6 flex flex-col gap-4 ">
                <h3 className="text-xl font-playfair text-[#17543e] font-medium">
                  <a href="inhale-namaste-mudra-bandha">
                    {" "}
                    Breath of fire inhale
                  </a>
                </h3>
                <p className="text-[#525C58] font-raleway text-[16px] font-normal">
                  Cras tempus, nunc a blandit porttitor, nunc ligula ornare
                  orci, nec vestibulum odio neque non
                </p>
                <a className="font-xl font-raleway font-[600] text-[#cfa649]" href="/">Learn More</a>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageBlog;
